import React from 'react';

const Pagination = ({
  page,
  rowsPerPage,
  filteredTickets,
  onPageChange,
  onRowsPerPageChange
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 font-poppins">
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-700">Rows per page:</span>
        <select
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
          className="px-2 py-1 border border-gray-300 rounded text-sm"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
        </select>
      </div>
      
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-700">
          {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, filteredTickets.length)} of {filteredTickets.length}
        </span>
        
        <div className="flex gap-1">
          <button
            onClick={() => onPageChange(null, 0)}
            disabled={page === 0}
            className="px-2 py-1 border border-gray-300 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
          >
            First
          </button>
          <button
            onClick={() => onPageChange(null, page - 1)}
            disabled={page === 0}
            className="px-2 py-1 border border-gray-300 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
          >
            Previous
          </button>
          <button
            onClick={() => onPageChange(null, page + 1)}
            disabled={page >= Math.ceil(filteredTickets.length / rowsPerPage) - 1}
            className="px-2 py-1 border border-gray-300 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
          >
            Next
          </button>
          <button
            onClick={() => onPageChange(null, Math.ceil(filteredTickets.length / rowsPerPage) - 1)}
            disabled={page >= Math.ceil(filteredTickets.length / rowsPerPage) - 1}
            className="px-2 py-1 border border-gray-300 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
          >
            Last
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
